// extracted by mini-css-extract-plugin
export default {"cardContainer":"cardContainer--qJS9g","heading":"heading--qJS9g","imageHeading":"imageHeading--qJS9g","card":"card--qJS9g","imageWrapper":"imageWrapper--qJS9g"};